// corporate colors
export const corporateRed = 'rgb(209, 0, 25)';
export const corporateBlue = 'rgb(56, 83, 112)';
export const corporateGrey = 'rgb(135, 141, 151)';
export const corporateBlueLight = 'rgb(215, 219, 228)';
export const corporateGreyLight = 'rgb(241, 242, 246)';

// spider colors
export const spiderRed = corporateRed;
export const spiderGreen = 'rgb(12, 140, 30)';
export const spiderGrange = 'rgb(255, 161, 0)';
